<template>
  <div class="order-detail">
    <div class="header">
      <div class="back-btn" @click="goBack">
        <el-icon :size="20"><ArrowLeft /></el-icon>
        <span class="back-text">返回</span>
      </div>
      <div class="page-title">
        <h2>订单详情</h2>
      </div>
      <span></span>
    </div>

    <div v-loading="!orderData.id" class="content">
      <template v-if="orderData.id">
        <!-- 交易信息 -->
        <div class="section-wrapper transaction-section section-wrapper">
          <template v-if="orderData.status == 'cancel'">
            <div class="n1_title">订单已取消</div>
          </template>
          <template v-else-if="orderData.status == 'wait_pay'">
            <div class="n1_title">订单待付款</div>
            <div class="n1_desc">您的订单已确认请尽快完成付款哦</div>
          </template>
          <template v-else-if="orderData.status == 'wait_confirm'">
            <div class="n1_title">订单已付款，待确认</div>
            <div class="n1_desc">我们将尽快确认订单，请稍等~</div>
          </template>
          <template v-else-if="orderData.status == 'preparing'">
            <div class="n1_title">订单备货中</div>
            <div class="n1_desc">您的订单备货中~</div>
          </template>
          <template v-else-if="orderData.status == 'partial_delivery'">
            <div class="n1_title">订单部分发货</div>
            <div class="n1_desc">您的订单部分发货~</div>
          </template>
          <template v-else-if="orderData.status == 'wait_receive'">
            <div class="n1_title">你的订单已发货</div>
            <div class="n1_desc">请耐心等待宝贝送达你的手中~</div>
          </template>
          <template v-else-if="orderData.status == 'wait_comment'">
            <div class="n1_title">订单待评价</div>
            <div class="n1_desc">您的订单待评价~</div>
          </template>
          <template v-else-if="orderData.status == 'wait_pickup'">
            <div class="n1_title">订单待自提</div>
            <div class="n1_desc">您的订单待自提~</div>
          </template>
          <template v-if="orderData.status == 'complete'">
            <div class="n1_title">交易完成</div>
          </template>
        </div>
        <!-- 收货信息 -->
        <div class="section-wrapper receiving-section">
          <div class="n2_icon address_icon">
            <el-icon color="#999" size="24"><Location /></el-icon>
          </div>
          <div class="n2_address_info">
            <div class="n2_address_name">
              <div class="address_name">收货人{{ orderData.receiveInfo.consignee || '' }}</div>
              <div class="address_tel">{{ orderData.receiveInfo.mobile || '' }}</div>
            </div>
            <div class="n2_address" v-if="orderData.deliveryType == 'EXPRESS'">
              {{ orderData.receiveInfo.province || '' }} {{ orderData.receiveInfo.city || '' }}
              {{ orderData.receiveInfo.county || '' }}
              {{ orderData.receiveInfo.address || '' }}
            </div>
            <div v-if="orderData.deliveryType == 'pickup'" class="n2_address">
              自提点：{{ orderData.pickupInfo.name }}
            </div>
          </div>
        </div>
        <!-- 商品信息 -->
        <div class="section-wrapper goods-section">
          <!-- 商品列表 -->
          <GoodsList :goods-list="orderData.orderGoods ?? []" />
          <!-- 买家留言 -->
          <div class="Message">
            <div class="Message_left" style="width: 85px">买家留言</div>
            <div class="Message_value">{{ orderData.leaveMessage || '无' }}</div>
          </div>
          <!-- 订单合计 -->
          <div class="order_total">
            <div class="total_item">
              <div class="item_left">优惠券</div>
              <div class="item_right">¥ {{ orderData.discountAmount || '0.00' }}</div>
            </div>
            <div class="total_item">
              <div class="item_left">促销优惠</div>
              <div class="item_right">¥ {{ orderData.discount_price || '0.00' }}</div>
            </div>
            <div class="total_item">
              <div class="item_left">运费（快递）</div>
              <div class="item_right">¥ {{ orderData.expressAmount || '0.00' }}</div>
            </div>
            <div class="total_item">
              <div class="item_left" style="color: #333333; font-size: 14px; font-weight: bold">
                总价
              </div>
              <div class="item_right">¥ {{ orderData.originalAmount || orderData.amount }}</div>
            </div>
          </div>
          <div class="payment">
            <div class="payment_left">实付款</div>
            <div class="payment_right">¥ {{ orderData.amount || '' }}</div>
          </div>
        </div>
        <!-- 订单信息 -->
        <div class="section-wrapper order-section">
          <div class="n4_header">订单详情</div>
          <div class="n4_info">
            <div class="n4_item">
              <div class="n4_item_left">订单编号：</div>
              <div class="n4_item_right">{{ orderData.number }}</div>
            </div>
            <div class="n4_item">
              <div class="n4_item_left">支付交易号：</div>
              <div class="n4_item_right">{{ orderData.payNumber || '---' }}</div>
            </div>
            <div class="n4_item">
              <div class="n4_item_left">创建时间：</div>
              <div class="n4_item_right">{{ calcTime(orderData.createAt) }}</div>
            </div>
            <div class="n4_item">
              <div class="n4_item_left">支付时间：</div>
              <div class="n4_item_right">{{ calcTime(orderData.payAt) || '待支付' }}</div>
            </div>
            <div class="n4_item" v-if="orderData.orderDeliveries">
              <div class="n4_item_left">发货时间：</div>
              <div class="n4_item_right">{{ calcTime(orderData.orderDeliveries.createAt) }}</div>
            </div>
          </div>
          <div class="n4_btn">
            <div
              class="btn_pay btns"
              v-if="orderData.status == 'wait_comment'"
              @click="() => orderEvaluateDialogRef.show(orderId)"
            >
              评价订单
            </div>
            <div
              class="btn_pay btns"
              v-if="orderData.status == 'wait_pay'"
              @click="payTypeDialogRef?.show"
            >
              支付订单
            </div>
            <div
              class="btn_primary btns"
              v-if="['partial_delivery', 'wait_receive', 'wait_pickup'].includes(orderData.status)"
              @click="() => expressTrackDialogRef?.show(orderId)"
            >
              查看物流
            </div>
            <div
              class="btn_pay btns"
              v-if="['partial_delivery', 'wait_receive', 'wait_pickup'].includes(orderData.status)"
              @click="orderConfirmHandle"
            >
              确认收货
            </div>
          </div>
        </div>
      </template>
    </div>

    <PayTypeDialog ref="payTypeDialogRef" @confirm="payTypeConfirmHandle" />
    <PayQrCodeDialog ref="payQrCodeDialogRef" />
    <ExpressTrackDialog ref="expressTrackDialogRef" />
    <OrderEvaluateDialog ref="orderEvaluateDialogRef" @success="getInitData" />
  </div>
</template>

<script setup>
  import { ref, unref, useTemplateRef } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { ElMessage, ElMessageBox } from 'element-plus'

  import GoodsList from '@/components/GoodsList.vue'
  import PayTypeDialog from '@/components/PayTypeDialog.vue'
  import PayQrCodeDialog from '@/components/PayQrCodeDialog.vue'
  import ExpressTrackDialog from '@/components/ExpressTrackDialog.vue'
  import OrderEvaluateDialog from '@/components/OrderEvaluateDialog.vue'
  import { orderConfirm, orderDetail } from '@/api/user'
  import { calcTime } from '@/utils'
  import { payApi } from '@/api/custom'

  const router = useRouter()
  const route = useRoute()
  const { id: orderId } = route.query

  const expressTrackDialogRef = useTemplateRef('expressTrackDialogRef')
  const orderEvaluateDialogRef = useTemplateRef('orderEvaluateDialogRef')

  const orderData = ref({})

  const payTypeDialogRef = useTemplateRef('payTypeDialogRef')
  const payQrCodeDialogRef = useTemplateRef('payQrCodeDialogRef')
  const payTypeConfirmHandle = async payType => {
    try {
      const payData = await payApi({
        id: unref(orderData).id,
        channel: payType,
        platform: 'PCWEB'
      })
      if (payData) {
        unref(payQrCodeDialogRef)?.show({
          payType,
          price: unref(orderData).amount,
          qrCodeUrl: payData,
          validityTime: 180
        })
      } else {
        ElMessage.error('支付失败')
      }
    } catch (error) {
      ElMessage.error(error.message || '支付失败')
      console.log(error, 'error')
    }
  }

  const orderConfirmHandle = () => {
    ElMessageBox.confirm('是否确认收货？')
      .then(async () => {
        const result = await handleRequest(orderConfirm, orderId)
        if (result) {
          ElMessage.success('确认收货成功')
          getInitData()
        }
      })
      .catch(() => {})
  }

  const goBack = () => {
    router.back()
  }

  const getInitData = () => {
    orderDetail(orderId)
      .then(res => res && (orderData.value = res))
      .catch(console.log)
  }
  getInitData()

  const handleRequest = async (fn, ...args) => {
    if (typeof fn !== 'function') return
    try {
      return (await fn.call({}, ...args)) || true
    } catch (error) {
      ElMessage.error(error)
    }
  }
</script>

<style lang="scss" scoped>
  .order-detail {
    background: #ffffff;
    padding: 0;

    .header {
      position: relative;
      z-index: 100;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      background: #ffffff;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .back-btn {
        display: flex;
        align-items: center;
        cursor: pointer;

        .back-text {
          font-size: 16px;
          color: #333;
        }
      }

      .page-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }
    }

    .content {
      height: calc(100vh - 64px);
      background-color: #f0f2f5;
      overflow: auto;

      .section-wrapper {
        padding: 15px 40px;
      }

      .transaction-section {
        width: 100%;
        background: #333;
        color: #fff;

        .n1_title {
          font-size: 14px;
        }

        .n1_desc {
          font-size: 12px;
          margin-top: 8px;
        }
      }

      .receiving-section {
        display: flex;
        align-items: center;
        color: #636673;
        font-size: 14px;
        background: #fff;

        .address_icon {
          margin-right: 10px;
        }

        .n2_address_name {
          display: flex;
          margin-bottom: 3px;

          .address_tel {
            margin-left: 10px;
          }
        }
      }

      .goods-section {
        padding-top: 0;
        border-top: 15px solid #f2f3f5;
        background-color: #fff;

        /* 留言 */
        .Message {
          border-bottom: 1px solid #f2f3f5;
          padding-left: 15px;
          padding-right: 15px;
          color: #333;
          font-size: 14px;
          display: flex;
          align-items: center;
          padding-top: 10px;
          padding-bottom: 10px;

          .Message_value {
            color: #636673;
            margin-left: 10px;
          }
        }

        /* 订单合计 */
        .order_total {
          padding: 15px;
          padding-bottom: 5px;
          border-bottom: 1px solid #f2f3f5;
          color: #636673;
          font-size: 14px;

          .total_item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 4px;
          }
        }

        .payment {
          padding: 7px 15px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .payment_left {
            color: #333333;
            font-size: 14px;
            font-weight: bold;
          }

          .payment_right {
            color: #f51d32;
            font-size: 20px;
            font-family: 'Bebas';
          }
        }
      }

      .order-section {
        width: 100%;
        height: auto;
        padding: 20px 40px 60px;
        background: #ffffff;
        margin-top: 10px;

        .n4_header {
          border-left: 3px solid #dc181a;
          font-size: 16px;
          line-height: 17px;
          padding-left: 5px;
        }

        .n4_info {
          font-size: 14px;
          color: #636673;
          margin-top: 10px;
        }

        .n4_item {
          display: flex;
          margin-top: 7px;
        }

        .n4_item_left {
          width: 100px;
        }

        .n4_btn {
          margin-top: 40px;
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
        }

        .btns {
          width: 160px;
          display: block;
          height: 40px;
          line-height: 40px;
          background: #c0c4cc;
          text-align: center;
          margin-bottom: 10px;
          font-size: 14px;
          color: #fff;
          border-radius: 20px;
          cursor: pointer;
          user-select: none;
        }

        .btn_pay {
          background: #ff9f3e;
          color: #fff;
        }

        .btn_primary {
          background: #419fff;
          color: #fff;
        }
      }
    }
  }
</style>
